import PropTypes from 'prop-types';
import {Controller, useFormContext} from 'react-hook-form';

import {LoadingButton} from '@mui/lab';
// @mui
import {
  Card,
  Chip,
  Grid,
  Stack,
  MenuItem,
  TextField,
  Container,
  Typography,
  Autocomplete
} from '@mui/material';

import useBasicDataFormOptions from "src/hooks/recipe/form/use-basic-data-form-options";

import {useTranslate} from 'src/locales';

import {LoadingScreen} from 'src/components/loading-screen'
// components
import {
  RHFSelect,
  RHFTextField,
} from 'src/components/hook-form';


// ----------------------------------------------------------------------

BasicDataForm.propTypes = {
  isEdit: PropTypes.bool,
  currentRecipe: PropTypes.object,
  onSubmit: PropTypes.func
};

export default function BasicDataForm({isEdit, currentRecipe, onSubmit}) {
  const {
    control,
    getValues,
    setValue,
    formState: {isSubmitting}
  } = useFormContext();

  const {t} = useTranslate();
  const basicDataFormOptions = useBasicDataFormOptions(!isEdit ? setValue : null);

  if (!basicDataFormOptions || !basicDataFormOptions.isLoaded) {
    return <LoadingScreen/>;
  }

  return (
    <Container disableGutters id="basic-data-form-container">
      <Grid container spacing={3}>
        <Grid item xs={12} md={7}>
          <Card sx={{p: 3}}>
            <Stack spacing={3}>
              <Typography variant="h4">{t('page.recipe.add.form.basic.title')}</Typography>
              <RHFTextField name="name" label={t('page.recipe.add.form.basic.recipe_title')} required/>
              <Typography variant="h5">{t('page.recipe.add.form.basic.source_description')}</Typography>
              <RHFTextField name="source_recipe_url" label={t('page.recipe.add.form.basic.source_recipe_url')}/>
            </Stack>
          </Card>
        </Grid>

        <Grid item xs={12} md={5}>
          <Stack spacing={3}>
            <Card sx={{p: 3}}>
              <Stack spacing={3} mt={2}>
                <Controller
                  name="mealTypes"
                  control={control}
                  render={({field, fieldState}) => (
                    <Autocomplete
                      value={field.value || []}
                      multiple
                      freeSolo
                      openOnFocus
                      autoComplete
                      autoSelect
                      onChange={(event, newValue) => field.onChange(newValue)}
                      isOptionEqualToValue={(option, value) => option.value === value.value}
                      filterSelectedOptions
                      options={basicDataFormOptions.mealTypeList}
                      renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                          <Chip {...getTagProps({index})} key={option.value} size="small"
                                label={option.label}/>
                        ))
                      }
                      renderInput={(params) =>
                        <TextField
                          {...params}
                          label={t('page.recipe.add.form.basic.meal_types')}
                          variant="outlined"
                          error={!!fieldState.error}
                          helperText={fieldState.error?.message}
                        />
                      }
                      renderOption={(props, option) => (
                        <li {...props} key={option.value}>
                          {option.label}
                        </li>
                      )}
                    />
                  )}
                />

                <RHFSelect id="for_how_many_person" key="for_how_many_person" name="for_how_many_person"
                           label={t('page.recipe.add.form.basic.for_how_many_person')}>
                  {basicDataFormOptions.forHowManyPersonList.map((option) => (
                    <MenuItem id={option.value} key={option.value} value={option.value} selected={option.value === getValues('for_how_many_person')}>
                      {option.label}
                    </MenuItem>
                  ))}
                </RHFSelect>

                <RHFSelect id="time_consuming" key="time_consuming" name="time_consuming" label={t('page.recipe.add.form.basic.time_consuming')}>
                  {basicDataFormOptions.timeConsumingList.map((option) => (
                    <MenuItem id={`time_consuming-${option.value}`} key={`time_consuming-${option.value}`}
                              value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </RHFSelect>
              </Stack>
            </Card>
            <LoadingButton type="submit" variant="contained" size="large" loading={isSubmitting}>
              {t('page.recipe.add.form.basic.next_step')}
            </LoadingButton>
          </Stack>
        </Grid>
      </Grid>
    </Container>
  );
}
